import * as React from "react"
import { SVGProps } from "react"
const RoomServiceCommand = (props: SVGProps<SVGSVGElement>) => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M25.6317 20.9997V22.1663C25.6317 24.0913 25.6317 25.6663 22.1317 25.6663H5.79834C2.29834 25.6663 2.29834 24.0913 2.29834 22.1663V20.9997C2.29834 20.358 2.82334 19.833 3.46501 19.833H24.465C25.1067 19.833 25.6317 20.358 25.6317 20.9997Z"
            fill={props.color || "#000"}
        />
        <path
            d="M16.8116 6.04307C16.8699 5.80973 16.9049 5.58807 16.9166 5.34307C16.9516 3.98973 16.1233 2.79973 14.8166 2.44973C12.8566 1.91307 11.0833 3.38307 11.0833 5.24973C11.0833 5.52973 11.1183 5.7864 11.1883 6.04307C6.97661 6.9414 3.81494 10.6864 3.81494 15.1664V16.9164C3.81494 17.5581 4.33994 18.0831 4.98161 18.0831H23.0066C23.6483 18.0831 24.1733 17.5581 24.1733 16.9164V15.1664C24.1733 10.6864 21.0233 6.95307 16.8116 6.04307ZM17.4999 13.7081H10.4999C10.0216 13.7081 9.62494 13.3114 9.62494 12.8331C9.62494 12.3547 10.0216 11.9581 10.4999 11.9581H17.4999C17.9783 11.9581 18.3749 12.3547 18.3749 12.8331C18.3749 13.3114 17.9783 13.7081 17.4999 13.7081Z"
            fill={props.color || "#000"}
        />
    </svg>
)

export default RoomServiceCommand
